export type PlanManagementMessages = {
  planDataCardTitle: string;
  billingDetailsCardTitle: string;
  contractSectionTitle: string;
  billingSectionTitle: string;
  feesSectionTitle: string;
  activeContractLabel: string;
  paymentsButton: string;
  payInvoiceButton: string;
  nextMonthlyPaymentLabel: string;
  dueDayLabel: string;
  fixedMonthlyFeeTypeLabel: string;
  noActivePlanMessage: string;
};

export const PLAN_MANAGEMENT_MESSAGES: PlanManagementMessages = {
  planDataCardTitle: "Dados do plano",
  billingDetailsCardTitle: "Detalhes de cobrança",
  contractSectionTitle: "Contrato",
  billingSectionTitle: "Cobrança",
  feesSectionTitle: "Tarifas",
  activeContractLabel: "Em vigor",
  paymentsButton: "Pagamentos",
  payInvoiceButton: "Pagar",
  nextMonthlyPaymentLabel: "Próximo pagamento mensal",
  dueDayLabel: "Dia de vencimento",
  fixedMonthlyFeeTypeLabel: "Tipo de mensalidade",
  noActivePlanMessage: "Nenhum plano ativo encontrado",
};

export default PLAN_MANAGEMENT_MESSAGES;
